// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__KW-ZX","icon":"SortAdornment_icon__jSjA6","up":"SortAdornment_up__MYVks","down":"SortAdornment_down__3WN1D","active":"SortAdornment_active__NwYyg"};